import { THEME_COLORS } from "../themes/DarkLight";
import { isNotNullOrUndefined } from "./isNotNullOrUndefined";
export interface GlobalAlertCardButton {
  text: string;
  onClick: Function | null;
  backgroundColor: string;
  textColor: string;
}
export type GlobalAlertCardImage =
  | "https://images.pexels.com/photos/19015147/pexels-photo-19015147.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load"
  | "https://images.pexels.com/photos/19015149/pexels-photo-19015149.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load"
  | "https://images.pexels.com/photos/19015195/pexels-photo-19015195.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load";

export const resultToAlertCardImage = {
  success:
    "https://images.pexels.com/photos/19015149/pexels-photo-19015149.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  failure:
    "https://images.pexels.com/photos/19015147/pexels-photo-19015147.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  pending:
    "https://images.pexels.com/photos/19015195/pexels-photo-19015195.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
};

export default class GlobalAlertCardBuilder {
  private alertCard: HTMLElement | null;
  private content: HTMLElement | null;
  private bannerImage: HTMLElement | null;
  private container: HTMLElement | null;
  private normalButton: HTMLElement | null;
  private notGreatButton: HTMLElement | null;
  private manualCancelButton: HTMLElement | null;
  constructor() {
    this.manualCancelButton = document.getElementById(
      "global-alert-card-manual-cancel-button"
    );
    this.container = document.getElementById("global-alert-card-container");
    this.alertCard = document.getElementById("global-alert-card");
    this.content = document.getElementById("global-alert-card-content");
    this.bannerImage = document.getElementById(
      "global-alert-card-banner-image"
    );
    this.normalButton = document.getElementById("normalButton");
    this.notGreatButton = document.getElementById("normalButton2");
  }

  static connect() {
    return new GlobalAlertCardBuilder();
  }

  // Method to fill and display the alert card
  buildAlertCard(
    alertTextContent: string,
    result: "success" | "failure" | "pending",
    globalAlertCardButton1: GlobalAlertCardButton | null,
    globalAlertCardButton2: GlobalAlertCardButton | null,
    globalAlertCardBackgroundColor: string | null,
    disableManualCancel?: boolean,
    manualCancelButtonColor?: string
  ) {
    if (!this.alertCard || !this.content || !this.bannerImage) {
      console.error("Alert card elements not found.");
      return;
    }
    if (!globalAlertCardButton1) {
      if (this.normalButton) {
        this.normalButton.style.display = "none";
      }
    }
    if (!globalAlertCardButton2) {
      if (this.notGreatButton) {
        this.notGreatButton.style.display = "none";
      }
    }

    if (alertTextContent) {
      this.content!.firstChild!.textContent = alertTextContent;
    }

    if (result) {
      this.bannerImage.innerHTML = `<img src="${resultToAlertCardImage[result]}" alt="Banner Image" />`;
    }

    if (this.normalButton && globalAlertCardButton1) {
      this.normalButton.textContent = globalAlertCardButton1.text || "Great";
      this.normalButton.style.backgroundColor =
        globalAlertCardButton1.backgroundColor || "#4CAF50";
      this.normalButton.style.color =
        globalAlertCardButton1.textColor || "#fff";
      this.normalButton.addEventListener("click", () => {
        globalAlertCardButton1.onClick !== null
          ? globalAlertCardButton1.onClick()
          : (this.alertCard!.style.display = "none");
        this.alertCard!.style.display = "none";
      });
    }

    if (this.notGreatButton && globalAlertCardButton2) {
      console.log("button 2 ");

      this.notGreatButton.textContent =
        globalAlertCardButton2.text || "Not great";
      this.notGreatButton.style.backgroundColor =
        globalAlertCardButton2.backgroundColor || "#f44336";
      this.notGreatButton.style.color =
        globalAlertCardButton2.textColor || "#fff";
      this.notGreatButton.addEventListener("click", () => {
        globalAlertCardButton2.onClick !== null
          ? globalAlertCardButton2.onClick()
          : (this.alertCard!.style.display = "none");
        this.alertCard!.style.display = "none";
      });
    }
    if (this.manualCancelButton) {
      this.manualCancelButton.style.backgroundColor =
        manualCancelButtonColor ?? "black";
      this.manualCancelButton.addEventListener("click", () => {
        if (this.alertCard && !isNotNullOrUndefined(disableManualCancel)) {
          this.alertCard.style.display = "none";
        } else {
        }
      });
    }
    this.container!.style.backgroundColor =
      globalAlertCardBackgroundColor ?? "white";
    this.alertCard.style.display = "block";
  }
  displayDefaultAlertCard(
    alertTextContent: string,
    result: "pending" | "success" | "failure",
    theme: "dark" | "light",
    buttonText: string | null
  ) {
    if (!this.alertCard || !this.content || !this.bannerImage) {
      console.error("Alert card elements not found.");
      return;
    }
    if (this.notGreatButton) {
      this.notGreatButton.style.display = "none";
    }
    if (alertTextContent) {
      this.content.textContent = alertTextContent;
    }

    if (result) {
      this.bannerImage.innerHTML = `<img src="${resultToAlertCardImage[result]}" alt="Banner Image" />`;
    }

    if (this.normalButton) {
      this.normalButton.textContent = buttonText ?? "I understand";
      this.normalButton.style.backgroundColor =
        THEME_COLORS[theme].inverse_theme;
      this.normalButton.style.color = THEME_COLORS[theme].full_theme;
      this.content.style.color = THEME_COLORS[theme].inverse_theme;
      this.normalButton.addEventListener("click", () => {
        this.alertCard!.style.display = "none";
      });
    }
    if (this.manualCancelButton) {
      this.manualCancelButton.addEventListener("click", () => {
        if (this.alertCard) {
          this.alertCard.style.display = "none";
        }
      });
    }
    this.container!.style.backgroundColor = THEME_COLORS[theme].full_theme;
    this.content.style.marginBottom = "30px";

    this.alertCard.style.display = "block";
  }
}
